import React, { useState, useRef, useEffect } from 'react';
import get from "lodash/get";

import ScrollIcon from "../../assets/images/chatbot/scroll.svg";
import GradientIcon from "../../assets/images/chatbot/gradient.svg";
import DefaultBrandImage from "../../assets/images/chat/company_placeholder_round.svg";

import { hasDivScrollEndReached } from '../../utils/helper';
import NoData from './NoData';


const Listing = ({ data, label, handleClick, isReportListing, isCompanyListing, isSearching }) => {
    if (!data || !data.length) return null;
    return (
        <div className={`context-list__container ${isReportListing ? 'report-listing__container' : ''}`}>
            {(isCompanyListing && !isSearching) ? null : <p className='context-list__label'>{label}</p>}
            {data.map((each) => {
                return (
                    <span span
                        onClick={() => handleClick(each)}
                        key={each.id}
                        className='context-list--item'>
                        {!isReportListing ?
                            <span className='company-logo'>
                                <img src={each.image || DefaultBrandImage} alt={each.name} />
                            </span> : null}
                        <span> {isReportListing ? each.title : each.name}</span>
                    </span >
                )
            })}
        </div>
    )
}

function WelcomeScreen(props) {
    const { handleSubmitContext, handleCompanyChange, company, value = "" } = props;

    const searchValue = value.toLowerCase();

    const [showScrollUI, setShowScrollUI] = useState(false);
    const boxRef = useRef(null);

    const contextList = get(props, "list", []);

    const filteredCompaniesList = get(props, "companyList", []).filter(each => (each.name || "").toLowerCase().includes(searchValue.toLowerCase()));

    const filteredReportList = contextList.filter((each) => {
        if (company) {
            // Only filter by company, ignore searchValue
            return each.company_id === company.id;
        } else {
            // Only filter by searchValue if provided
            return searchValue
                ? each.title.toLowerCase().includes(searchValue.toLowerCase())
                : true; // return all if no searchValue
        }
    });

    const isListEmpty = Boolean(contextList.length === 0);

    const isSearchListEmpty = value.length && filteredCompaniesList.length === 0 && filteredReportList.length === 0;

    const handleScroll = () => {
        const elem = boxRef.current;
        if (hasDivScrollEndReached(elem)) {
            setShowScrollUI(false);
        } else {
            setShowScrollUI(true);
        }
    }

    useEffect(() => {
        const el = boxRef.current;

        const checkScroll = () => {
            if (!el) return;
            const hasScroll = el.scrollHeight > el.clientHeight;
            setShowScrollUI(hasScroll);
        };

        checkScroll();
        const resizeObserver = new ResizeObserver(checkScroll);
        if (el) resizeObserver.observe(el);

        return () => {
            if (el) resizeObserver.unobserve(el);
        };
    }, [value]);

    if (isListEmpty || isSearchListEmpty) {
        return (
            <NoData isSearch={value.length} />
        )
    }
    return (
        <>
            <div className='context-list' onScroll={handleScroll} ref={boxRef}>
                {(value.length && !company) ? <p style={{ flex: '1' }}>Search result: </p> : null}
                <>
                    {!company ?
                        <Listing
                            label="Companies:"
                            data={filteredCompaniesList}
                            handleClick={handleCompanyChange}
                            isSearching={searchValue.length}
                            isCompanyListing
                        />
                        : null}
                    {(company || value.length) ?
                        <Listing
                            label={company ? 'Available Reports:' : 'Reports:'}
                            data={filteredReportList}
                            handleClick={handleSubmitContext}
                            isReportListing
                        />
                        : null}
                </>
                <div className={`icon-container ${showScrollUI ? "show" : "hide"}`}>
                    <img className='gradient-img' src={GradientIcon} />
                    <img className='scroll-img' src={ScrollIcon} />
                </div>
            </div>
        </>

    )
}

export default WelcomeScreen